import { Box, Flex, Text } from "@chakra-ui/react";
import Card from "./Card";
import { Patient } from "../types/patient.types";
import { format } from "date-fns";

const KeyValue = ({ label, value, last = false }: { label: string; value: string, last?: boolean }) => {
  return (
    <Flex
      justifyContent="space-between"
      borderBottom={!last ? "solid 1px" : undefined}
      borderColor={!last ? "gray.200" : undefined}
      mx={4}
      py={2}
      alignItems={"center"}
    >
      <Text
        lineHeight="18px"
        fontSize="14px"
        fontWeight="400"
        color="gray.500"
        w="100%"
      >
        {label}
      </Text>
      <Text
        lineHeight="21px"
        fontSize="14px"
        fontWeight="400"
        textAlign="left"
        w="100%"
      >
        {value}
      </Text>
    </Flex>
  );
};

const PatientCard = ({ patient }: { patient?: Patient }) => {
  return (
    <Card w="100%">
      <Flex
        borderTopRadius="xl"
        py={2}
        borderBottom="solid 1px"
        borderColor="gray.200"
        w="100%"
        direction="column"
      >
        <Box borderBottom="solid 1px" borderColor="gray.200">
          <Text lineHeight="21px" fontSize="16px" fontWeight="600" px={4} py={4}>
            Patient
          </Text>
        </Box>
        <Flex direction="column" w="100%" mt={2}>
          <KeyValue
            label="Nom"
            value={`${patient?.firstName} ${patient?.lastName}`}
          />
          <KeyValue
            label="Date de naissance"
            value={
              patient?.birthDate
                ? format(patient?.birthDate, "dd/MM/yyyy")
                : "--/--/----"
            }
          />
          <KeyValue label="N interne de commande" value={"--"} last />
        </Flex>
      </Flex>
    </Card>
  );
};

export default PatientCard;
